import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/themetwo/icon-fav2.png'
import _imports_1 from '@/assets/themetwo/icon-fav1.png'


const _hoisted_1 = { class: "card_container" }
const _hoisted_2 = {
  key: 0,
  class: "img_loader"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: ""
}

import {  ref, watch } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useUserStore } from '@/stores/user';
import { useGameStore } from '@/stores/games';
import { toggleFavorite } from '@/view/game/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'gameCard',
  props: {
    gameImage: {
        type: String,
        default: () => ''
    },
    gameTypeId: {
        type: [Number, String],
    },
    gameIsFavorite: {
        type: Number
    }
},
  emits: ['clickGameCard','updateGameCategories'],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const statusRef = ref();
const isSuccess = ref(false);
const toastContent = ref('');
const loadingRef = ref();
const userStore = useUserStore()
const imageLoaded = ref(false);
const gameStore = useGameStore()
const isLoading = ref(false)
const props = __props;
const gameIsFavoriteLocal = ref(props.gameIsFavorite);

watch(() => props.gameIsFavorite, (newVal: any) => {
    gameIsFavoriteLocal.value = newVal
})
watch(() => props.gameImage, () => {
    imageLoaded.value = false;
})
const gameClickHandle = () => {
    emits('clickGameCard')
}
const onImageLoad = (e: Event) => {
    imageLoaded.value = true;
};

const onImageError = () => {
    imageLoaded.value = true;
};

const addToFavorite = () => {
    isLoading.value = true
    toggleFavorite({
        userId: userStore.id,
        gameId: props.gameTypeId || '',
        currentStatus: gameIsFavoriteLocal.value || '',
        loadingRef,
        onSuccess: (status, msg) => {
            isLoading.value = false
            gameIsFavoriteLocal.value = status;
            // showSuccess(msg || '');
            gameStore.getGameGroupListData();
            emits('updateGameCategories')
        },
        onError: (msg) => {
            showError(msg)
            isLoading.value = false
        }
    });
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}


return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!imageLoaded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_van_loading, {
              color: "#fff",
              type: "spinner",
              size: "24px"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        src: props.gameImage,
        class: "gameCard",
        style: _normalizeStyle({ visibility: imageLoaded.value ? 'visible' : 'hidden' }),
        alt: "",
        onLoad: onImageLoad,
        onError: onImageError,
        onClick: gameClickHandle
      }, null, 44, _hoisted_3),
      _createElementVNode("div", {
        class: "heart_icon",
        onClick: addToFavorite
      }, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(_component_van_loading, {
              key: 0,
              type: "spinner",
              size: "15"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (gameIsFavoriteLocal.value == 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6))
            ]))
      ])
    ]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})